import React, {useEffect} from "react";
import {useLocation} from "react-router-dom";

const effectiveDate = "May 8, 2026";

export default function TanglaoOsSubmission() {
  const {pathname} = useLocation();

  useEffect(() => {
    const pathToSectionId = {
      "/tanglao-os/privacy": "privacy",
      "/tanglao-os/user-data-deletion": "user-data-deletion",
    };

    const sectionId = pathToSectionId[pathname];
    if (!sectionId) {
      return;
    }

    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({behavior: "auto", block: "start"});
    }
  }, [pathname]);

  return (
    <main className="app-info-page">
      <section className="app-info-hero">
        <div>
          <p className="section-eyebrow">Tanglao OS</p>
          <h1>App Store submission details</h1>
          <p className="app-info-hero__lede">
            Public support information for Tanglao OS, including the privacy
            policy URL, account and user data deletion instructions, category
            recommendation, and app icon asset reference.
          </p>
        </div>
        <img
          className="app-info-hero__icon"
          src="/tanglao-os/app-icon.svg"
          alt="Tanglao OS app icon"
        />
      </section>

      <section className="app-info-grid">
        <article id="privacy" className="panel app-info-card">
          <p className="section-eyebrow">Privacy policy URL</p>
          <h2>Tanglao OS Privacy Policy</h2>
          <p className="app-info-card__meta">Effective date: {effectiveDate}</p>
          <p>
            Tanglao OS is operated by Franz Noel Tanglao. This policy explains
            what information may be collected when you use Tanglao OS and how
            that information is handled.
          </p>
          <h3>Information collected</h3>
          <p>
            Tanglao OS may collect account information, profile details, content
            you choose to save in the app, support messages, and basic technical
            information such as device, browser, and diagnostic data. The app
            collects only the information needed to provide, maintain, secure,
            and improve the service.
          </p>
          <h3>How information is used</h3>
          <p>
            Information is used to operate Tanglao OS, respond to support
            requests, troubleshoot problems, protect the service, and improve
            the product experience. Tanglao OS does not sell personal
            information.
          </p>
          <h3>Sharing</h3>
          <p>
            Information may be processed by service providers that help host,
            secure, analyze, or support the app. Information may also be
            disclosed when required by law or to protect users, the service, or
            the public.
          </p>
          <h3>Retention and deletion</h3>
          <p>
            User data is retained only as long as needed for the purposes above
            or as required by law. You can request deletion of your account and
            associated user data using the process below.
          </p>
          <h3>Contact</h3>
          <p>
            For privacy questions, email{" "}
            <a href="mailto:franz@tanglao.org">franz@tanglao.org</a>.
          </p>
        </article>

        <article id="user-data-deletion" className="panel app-info-card">
          <p className="section-eyebrow">User data deletion</p>
          <h2>Request deletion of your Tanglao OS data</h2>
          <p>
            To request deletion of your Tanglao OS account and associated user
            data, email{" "}
            <a href="mailto:franz@tanglao.org?subject=Tanglao%20OS%20Data%20Deletion%20Request">
              franz@tanglao.org
            </a>{" "}
            with the subject line “Tanglao OS Data Deletion Request”.
          </p>
          <p>
            Include the email address or username connected to your Tanglao OS
            account so the request can be verified. Once verified, account data,
            profile data, saved app content, and support records associated with
            the account will be deleted unless retention is required for legal,
            security, or fraud-prevention reasons.
          </p>
          <p>
            Deletion requests are reviewed and completed within a reasonable
            period after verification. A confirmation email will be sent when
            the request has been completed.
          </p>
        </article>

        <article id="category" className="panel app-info-card">
          <p className="section-eyebrow">Category</p>
          <h2>Recommended App Store category</h2>
          <p>
            Suggested primary category: <strong>Productivity</strong>.
          </p>
          <p>
            If Tanglao OS is positioned primarily as a personal operating
            system, planning tool, knowledge workspace, or workflow assistant,
            Productivity is the closest general App Store category. If the app
            becomes more education-focused or developer-specific later, the
            category can be revisited.
          </p>
        </article>

        <article id="app-icon" className="panel app-info-card">
          <p className="section-eyebrow">App icon</p>
          <h2>1024 x 1024 icon asset</h2>
          <p>
            The App Store icon asset is available at{" "}
            <a href="/tanglao-os/app-icon-1024.png">
              /tanglao-os/app-icon-1024.png
            </a>
            . A scalable source version is available at{" "}
            <a href="/tanglao-os/app-icon.svg">/tanglao-os/app-icon.svg</a>.
          </p>
        </article>
      </section>
    </main>
  );
}
